import map from 'lodash/map'
import { useContext } from './Context'

export const useBoardCheckboxChange = () => {
  const { selectedBoard, setSelectedBoard } = useContext()

  return ({ _id, checked }) => {
    //fid the _id on the listWithCheck, and update it with the opposite of checked
    const newList = map(selectedBoard, (e) => {
      if (e._id === _id) {
        return { ...e, checked: !checked }
      }
      return e
    })
    setSelectedBoard(newList)
  }
}
